import _ from 'underscore';
import queryString from 'query-string';
import stringify from 'json-stable-stringify';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  OfflinePaymentInstructions,
  OfflinePaymentInstructionsVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<OfflinePaymentInstructionsVariables, null>) {
  const { variables } = params;

  const {
    locator,
    currencyCode,
    countryCode,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    currencyCode,
    countryCode,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/Payment/OfflinePaymentInstructions${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<
  OfflinePaymentInstructionsVariables,
  null
>({
  schema,
  dataPath: 'user:customer:offline_payment_instructions',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  OfflinePaymentInstructionsVariables,
  null,
  OfflinePaymentInstructions,
  OfflinePaymentInstructions[],
  OfflinePaymentInstructions[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: offlinePaymentInstructions => stringify(offlinePaymentInstructions),
  processorFn: response => response,
});
